// Component/GalleryP2.js
import React, { useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const GalleryP2 = () => {
  const images = [
    {
      src: "/img/portfolio/packshot/jw5ozrgwmxeq3dpytxmm.jpg",
      alt: "Photo 1",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img18_compression.jpg",
      alt: "Photo 2",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img16_compression.jpg",
      alt: "Photo 3",
      category: "Portrait",
    },

    {
      src: "/img/portfolio/packshot/img4.webp",
      alt: "Photo 4",
      category: "Portrait",
    },

    {
      src: "/img/portfolio/packshot/img3.webp",
      alt: "Photo 5",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img2.webp",
      alt: "Photo 6",
      category: "Portrait",
    },

    {
      src: "/img/portfolio/packshot/img9_compression.jpg",
      alt: "Photo 7",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img5_compression.jpg",
      alt: "Photo 8",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img14_compression.jpg",
      alt: "Photo 9",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/u4onctwerd4frwhiml9x.jpg",
      alt: "Photo 10",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img17_compression.jpg",
      alt: "Photo 11",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/c1mgjalvvwqqokgsv57s.jpg",
      alt: "Photo 12",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img11_compression.jpg",
      alt: "Photo 13",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img20_compression.jpg",
      alt: "Photo 14",
      category: "Portrait",
    },

    {
      src: "/img/portfolio/packshot/img10_compression.jpg",
      alt: "Photo 15",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/iqj9tundlvlr6sftsvnd.jpg",
      alt: "Photo 16",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img13_compression.jpg",
      alt: "Photo 18",
      category: "Portrait",
    },

    {
      src: "/img/portfolio/packshot/img21_compression.jpg",
      alt: "Photo 19",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/img15_compression.jpg",
      alt: "Photo 20",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/mqq7xcplkwdri9gxap2v.jpg",
      alt: "Photo 21",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/packshot/tnieablwgp0ldunxlohh.jpg",
      alt: "Photo 17",
      category: "Portrait",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <>
      {/* Section Header */}
      <section
        className="banner-header banner-img banner-img-top section-padding valign bg-img bg-fixed banner-overlay"
        data-overlay-darkgray="1"
        style={{
          backgroundImage:
            "url('/img/portfolio/packshot/img11_compression.jpg')",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <h1>Packshot</h1>
              <hr className="border-1 text-white" />
              <p>
                Sublimez vos créations avec des photographies de produits qui
                mettent en avant chaque détail et reflètent l’essence de vos
                créations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Portfolio */}
      <section className="projects2 section-padding bg-blck">
        <div className="container">
          <div className="row">
            {images.map((image, index) => (
              <div
                key={index}
                className="col-12 col-md-4 portfolio-masonry-wrapper-padding"
              >
                <div
                  className="gallery-item img-zoom"
                  onClick={() => {
                    setPhotoIndex(index);
                    setIsOpen(true);
                  }}
                >
                  <div className="gallery-box">
                    <div className="gallery-img">
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox */}
        {isOpen && (
          <Lightbox
            images={images.map((img) => ({ url: img.src, title: img.title }))}
            startIndex={photoIndex}
            onClose={() => setIsOpen(false)}
          />
        )}
      </section>
    </>
  );
};

export default GalleryP2;
